// reducer.js
import {
  FETCH_JOBSEEKER_REFERRAL_REQUEST,
  FETCH_JOBSEEKER_REFERRAL_SUCCESS,
  FETCH_JOBSEEKER_REFERRAL_FAILURE,
} from "../../actionTypes";

const initialState = {
  data: {},
  status: false,
  isLoading: false,
  message: "",
};

const referralJobseekerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JOBSEEKER_REFERRAL_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case FETCH_JOBSEEKER_REFERRAL_SUCCESS:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        data: action.payload.data,
      };
    case FETCH_JOBSEEKER_REFERRAL_FAILURE:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default referralJobseekerReducer;
